import { Filters } from '../../types'

export class FiltersNewSearch {
  private readonly excludedThemeKeys = [
    'quarentenaIsolamento',
    'orientacaoPsicopedagogica',
  ]

  toDomain(filters: Filters) {
    return {
      reasons: filters.temas
        ?.filter(theme => !this.excludedThemeKeys.includes(theme.key))
        ?.map(themes => ({
          key: themes?.id,
          value: themes?.value,
          label: themes.value,
        })),
      groupAreas: filters.areasGrupo?.map(groupAreas => ({
        key: groupAreas?.id,
        value: groupAreas?.value,
        label: groupAreas.value,
      })),
      approachs: filters.abordagens?.map(approachs => ({
        key: approachs?.id,
        value: approachs.value,
        label: approachs.value,
      })),
      specialties: filters.especialidades?.map(specialties => ({
        key: specialties.id,
        value: specialties.value,
        label: specialties.value,
      })),
      states: filters.estados?.map(states => ({
        ...states,
        value: states.key,
        label: states.value,
      })),
      ageGroups: filters.faixasEtarias?.map(ageGroup => ({
        key: ageGroup.key,
        value: ageGroup.value,
        label: ageGroup.value,
      })),
      genders: filters.generos?.map(gender => ({
        key: gender.key,
        label: gender.value,
        value: gender.value,
      })),
      ethnicities: filters.etnias?.map(ethnicity => ({
        key: ethnicity.key,
        value: ethnicity.value,
        label: ethnicity.value,
      })),
      durations: filters.duracaoConsulta?.map(duration => ({
        key: duration.key,
        value: duration.value,
        label: duration.value,
      })),
      allOptions: [
        {
          group: 'Motivos',
          items: filters.temas
            ?.filter(theme => !this.excludedThemeKeys.includes(theme.key))
            ?.map(theme => ({
              group: 'reasons',
              key: theme?.id,
              value: theme?.value,
              label: theme.value,
            })),
        },
        {
          group: 'Abordagem',
          items: filters.abordagens?.map(approach => ({
            group: 'approaches',
            key: approach?.id,
            value: approach.value,
            label: approach.value,
          })),
        },
        {
          group: 'Gênero',
          items: filters.generos?.map(gender => ({
            group: 'genders',
            key: gender.key,
            label: gender.value,
            value: gender.value,
          })),
        },
        {
          group: 'Etnia',
          items: filters.etnias?.map(ethnicity => ({
            group: 'ethnicities',
            key: ethnicity.key,
            value: ethnicity.value,
            label: ethnicity.value,
          })),
        },
      ],
    }
  }
}

export default new FiltersNewSearch()
